<template>

  <div id="gr_step_component">
      <div class="circle circle-active circle-active-step-1 active"><span class="active-number-step-1">1</span></div>
      <div class="divider"></div>
      <div class="circle circle-active">2</div>
      <div class="divider"></div>
      <div class="circle circle-active">3</div>
      <div class="divider"></div>
      <div class="circle circle-active">4</div>
  </div>
  <!-- FIN STEP COMPONENT -->

  <h1 class="gr-texte-black uk-margin-small-bottom">MERCI DE CONFIRMER QUE VOUS ÊTES BIEN UN COUREUR DE
L’EDITION GRAND RAID 2026</h1>

  <div>
    <form @submit.prevent="verifierCoureur" class="uk-form-stacked uk-flex uk-flex-top uk-width-1-1 uk-width-3-4@m uk-grid-small" uk-grid>

      <div class="uk-width-1-1">
          <label class="uk-form-label" for="form-stacked-nom">Nom*</label>
          <div class="uk-form-controls">
              <input class="uk-input uk-width-1-1" v-model="nom" @input="nom = nom.toUpperCase()" id="nom" required type="text" autocapitalize="characters" autocorrect="off" spellcheck="false" placeholder="Votre nom">
          </div>
      </div>

      <div class="uk-width-1-1">
          <label class="uk-form-label" for="form-stacked-nom">Prénom*</label>
          <div class="uk-form-controls">
              <input class="uk-input uk-width-1-1" v-model="prenom" @input="prenom = prenom.toUpperCase()" id="prenom" required type="text" autocapitalize="characters" autocorrect="off" spellcheck="false" placeholder="Votre prénom">
          </div>
      </div>

      <div class="uk-width-1-1">
          <label class="uk-form-label" for="form-stacked-nom">Numéro de dossard*</label>
          <div class="uk-form-controls">
              <input class="uk-input uk-width-1-1" v-model="dossard" id="dossard" required type="text" placeholder="Votre numéro de dossard">
          </div>
      </div>

      <div class="uk-width-1-1">
      	<button type="submit" class="uk-button cta-sfr-primary">Vérifier</button>
      </div>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      nom: "",
      prenom: "",
      dossard: "",
      coureurs: []
    };
  },
  mounted() {
    // Charger les données du fichier JSON en utilisant require
    const coureurs = require('@/assets/coureurs.json');
    this.coureurs = coureurs;
  },
  methods: {
    /**
     * Ramene un nom a une forme comparable, pour qu'une difference de saisie
     * n'empeche jamais un coureur de se reconnaitre :
     *   - majuscules
     *   - accents supprimes      (MELEARD == MÉLÉARD)
     *   - apostrophes unifiees   (D'ABRIGEON == D’ABRIGEON) <- le piege principal :
     *     20 noms du fichier officiel utilisent l'apostrophe typographique U+2019,
     *     alors qu'un clavier produit l'apostrophe droite U+0027.
     *   - tirets unifies         (JEAN-PIERRE == JEAN‐PIERRE)
     *   - espaces multiples reduits et espaces de bord retires
     */
    normaliser(valeur) {
      return (valeur || '')
        .normalize('NFD').replace(/[\u0300-\u036f]/g, '')
        .replace(/[\u2018\u2019\u02BC\u0060\u00B4]/g, "'")
        .replace(/[\u2010\u2011\u2012\u2013\u2014]/g, '-')
        .replace(/\s+/g, ' ')
        .trim()
        .toUpperCase();
    },
    verifierCoureur() {
      const nomSaisi     = this.normaliser(this.nom);
      const prenomSaisi  = this.normaliser(this.prenom);
      const dossardSaisi = String(this.dossard || '').trim();

      const coureur = this.coureurs.find(c =>
        this.normaliser(c.nom) === nomSaisi &&
        this.normaliser(c.prenom) === prenomSaisi &&
        String(c.numero_de_dossard).trim() === dossardSaisi
      );



      if (coureur) {
        if (coureur.course.toLowerCase() === 'grr') {
          // Stocker l'information que le coureur est de la Diagonale des Fous
          this.$store.commit('setIsDiagonale', true);
          this.$store.commit('setProductPrice', 0); // Exemple: Prix pour la Diagonale des Fous
        } else {
          // Le coureur n'est pas de la Diagonale des Fous, mais on continue le processus
          this.$store.commit('setIsDiagonale', false);
          this.$store.commit('setProductPrice', 3); // Exemple: Prix pour les autres courses
        }
        this.$store.commit('setDossard', coureur.numero_de_dossard);
        // Rediriger vers l'étape suivante
        this.$store.commit('gotoStep', { stepCommande: 1 });
      } else {
        //this.$router.push('/commande-non-disponible');
        alert('Coureur non trouvé. Veuillez vérifier vos nom, prenom et numero de dossard.');
      }
    }
  }
};
</script>
